import DataLoadError from '@/components/errors/DataLoadError';
import IconAlert from '@/components/common/IconAlert';
import {
  shouldShowDataLoadError,
  type ApiQueryError
} from '@/app/common/utils/apiErrorUtils';
import type { CheckAccessResponse } from '@/app/common/api/types/accessLevelApiTypes';
import type { ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type AccessLevelFailedProps = {
  tool_name: string;
  accessData?: CheckAccessResponse;
  onRetry: () => void;
  isRetrying?: boolean;
  error?: ApiQueryError;
};

const AccessLevelFailed = ({
  tool_name,
  accessData,
  onRetry,
  isRetrying,
  error
}: AccessLevelFailedProps) => {
  if (!accessData && shouldShowDataLoadError(true, error)) {
    return (
      <DataLoadError
        error={error}
        onRetry={onRetry}
        isRetrying={isRetrying}
      />
    );
  }

  return !accessData ? null : (
    accessData?.code !== 40001 && (
      <IconAlert variant="danger" className="my-2">
        <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-start align-items-md-center">
          <p className="mb-0 text-justify pe-3">
            {accessData?.code && accessData?.code === 40001 ? (
              <span>
                {(accessData?.data as unknown as ReactNode)}.
              </span>
            ) : accessData?.data?.expired_panel ? (
              <span>
                <span className="mb-2 d-block">
                  طرح شما به پایان رسیده، اما مسیر رشد و موفقیت سایت شما هنوز
                  ادامه داره!
                </span>
                با تمدید اشتراک خود، می‌تونید دوباره به تمام ابزارهای حرفه‌ای
                دسترسی داشته باشید، همراه شما هستیم تا به نتایج بهتر برسید :)
              </span>
            ) : (
              <span className="mb-0 text-justify pe-3">
                فقط طرح‌های <strong>استاندارد</strong> و <strong>حرفه‌ای</strong>{' '}
                می‌توانند از <strong>{tool_name}</strong> استفاده کنند.
              </span>
            )}
          </p>
          <Link
            to="/prorogate-or-upgrade/"
            className="text-decoration-none flex-shrink-0"
          >
            <Button variant="falcon-primary" size="sm">
              خرید طرح
            </Button>
          </Link>
        </div>
      </IconAlert>
    )
  );
};

export default AccessLevelFailed;
